import { cssVar, defineStyleConfig } from '@chakra-ui/styled-system'
import { asChakraVariable, themeColorSectionKeys } from '~/themes/colors/colors'

const { Tooltip } = themeColorSectionKeys.shared
const arrowBg = cssVar('popper-arrow-bg')
export const TooltipStyle = defineStyleConfig({
  baseStyle: {
    bg: Tooltip.Background,
    color: Tooltip.FontColor,
    borderRadius: '4px',
    [arrowBg.variable]: asChakraVariable(Tooltip.Background),
  },
})
